import Link from '@/atoms/Link/Link'
import { caveat } from '@/styles/fonts/fonts'
import Reveal from '../Reveal/Reveal'

interface Props {
  footerCta: StrapiFooterCTASharedComponent
}

function CaseStudyCta({ footerCta }: Props) {
  return (
    <section className="container | pb-[90px] pt-14">
      <Reveal className="relative overflow-hidden rounded-[40px] bg-linear-to-br from-[#1E2178] to-[#10133F] px-7 py-16 text-center text-white md:px-14 md:py-[74px]">
        <span
          aria-hidden
          className="pointer-events-none absolute left-1/2 -top-56 h-[440px] w-[700px] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(37,99,255,0.5),transparent_70%)]"
        />

        <h2 className="font-heading relative z-1 mx-auto mb-4 max-w-[680px] text-3xl font-extrabold leading-tight tracking-tight text-white md:text-h2 text-balance">
          {footerCta.title}
        </h2>
        {footerCta.description ? (
          <p className="relative z-1 mx-auto mb-8 max-w-[520px] text-base text-[#C3CDF2]">
            {footerCta.description}
          </p>
        ) : null}

        <div className="relative z-1 mt-8 flex flex-wrap justify-center gap-3.5">
          {footerCta.primaryCta?.title ? (
            <Link
              href={footerCta.primaryCta.href}
              className="inline-flex items-center justify-center rounded-full bg-[#2563FF] px-7 py-4 text-xs font-bold uppercase tracking-wider text-white shadow-[0_10px_26px_rgba(37,99,255,0.3)] transition hover:bg-[#1F4FE0] hover:-translate-y-0.5"
            >
              {footerCta.primaryCta.title}
            </Link>
          ) : null}
          {footerCta.secondaryCta?.title ? (
            <Link
              href={footerCta.secondaryCta.href}
              className="inline-flex items-center justify-center rounded-full bg-white px-7 py-4 text-xs font-bold uppercase tracking-wider text-[#1E2178] transition hover:-translate-y-0.5 hover:shadow-[0_14px_30px_rgba(0,0,0,0.25)]"
            >
              {footerCta.secondaryCta.title}
            </Link>
          ) : null}
        </div>

        <div
          className={`${caveat.className} relative z-1 mt-5 text-xl text-yellow-50`}
        >
          your growth story could be next ↑
        </div>
      </Reveal>
    </section>
  )
}

export default CaseStudyCta
